import { FeatureToggle } from 'src/state/types/featureToggle';
import { PlanTierFeature } from 'src/state/types/planTierFeatures';

/**
 * Determine if the feature list needs to have items removed based on feature toggles
 * @param userFt feature toggles that the user has
 * @param featureList full feature list
 * @returns Plan Tier Features that the user is allowed to see
 */
export const trimFeatures = (
  userFt: FeatureToggle[],
  featureList: PlanTierFeature[]
): PlanTierFeature[] => {
  return featureList.filter((item: PlanTierFeature) => {
    const itemFt = item.featureToggle;
    if (!itemFt) {
      // if no item feature toggle, we want it in the list
      return true;
    } else {
      // if item feature toggle, we only want the item if the user has the same feature toggle
      return userFt.some(
        (ft) =>
          ft.appName === itemFt.appName && ft.featureName === itemFt.featureName
      );
    }
  });
};
